import { render, staticRenderFns } from "./DocStoreComponent.vue?vue&type=template&id=27e8365c&"
import script from "./DocStoreComponent.vue?vue&type=script&lang=js&"
export * from "./DocStoreComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports